"use strict";

require("core-js/modules/es6.object.assign");
require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
var PasswordRules = function () {
  function PasswordRules() {}
  PasswordRules.prototype.passwordRule = function () {
    return Object.assign({}, this.userPasswordRule(), this.userPasswordConfirmRule());
  };
  PasswordRules.prototype.userPasswordRule = function () {
    $.validator.addMethod("userPassword", function (value) {
      if (value.length > 7) {
        return /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)/.test(value);
      }
    }, $.validator.format('Hasło musi zawierać przynajmniej (8 znaków, jedną małą i jedną wielką literę, jedną cyfrę i jeden znak specjalny)'));
  };
  PasswordRules.prototype.userPasswordConfirmRule = function () {
    $.validator.addMethod("userPasswordConfirm", function (value) {
      var object = $('#userPassword');
      if (!object.length) {
        object = $('#repassword');
      }
      var userPassword = object.val();
      if (value === userPassword) {
        return true;
      }
    }, $.validator.format('Hasła muszą być identyczne'));
  };
  return PasswordRules;
}();
exports.PasswordRules = PasswordRules;